import { render, staticRenderFns } from "./PromoCouponIdentification.vue?vue&type=template&id=472c316f&scoped=true&"
import script from "./PromoCouponIdentification.vue?vue&type=script&lang=js&"
export * from "./PromoCouponIdentification.vue?vue&type=script&lang=js&"
import style0 from "./PromoCouponIdentification.vue?vue&type=style&index=0&id=472c316f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472c316f",
  null
  
)

export default component.exports